var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2487_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.458 59.974a2.37 2.37 0 012.187 3.284 2.37 2.37 0 01-3.87.764 2.373 2.373 0 011.683-4.048zm37.206-14.671a2.372 2.372 0 11.003-4.745 2.372 2.372 0 01-.003 4.745zm0-9.707a7.344 7.344 0 00-7.337 7.338 7.3 7.3 0 00.388 2.332L42.479 58.168a7.308 7.308 0 00-6.021-3.162 7.353 7.353 0 00-6.581 4.104L8.105 47.628c-2.302-1.208-4.023-4.995-3.841-8.444.094-1.799.715-3.196 1.664-3.736.6-.338 1.323-.31 2.092.09l.142.079c5.771 3.037 24.65 12.983 25.447 13.351 1.225.57 1.907.8 4-.192l39.028-20.298c.574-.216 1.242-.766 1.242-1.6 0-1.154-1.195-1.61-1.198-1.61-2.22-1.062-5.633-2.659-8.96-4.218-7.115-3.331-15.178-7.104-18.718-8.96-3.058-1.6-5.518-.25-5.957.02l-.85.421C26.258 20.413 4.928 30.977 3.713 31.715 1.544 33.038.197 35.674.02 38.945c-.27 5.187 2.373 10.597 6.156 12.578l23.025 11.873a7.341 7.341 0 007.256 6.284 7.347 7.347 0 007.334-7.222l25.36-13.746a7.33 7.33 0 004.512 1.555A7.344 7.344 0 0081 42.93a7.344 7.344 0 00-7.337-7.337",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2487_1453"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h81v81H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitBook);
export default __webpack_public_path__ + "static/media/GitBook.70827ab2010cf1405d16e0f9dbaf84d7.svg";
export { ForwardRef as ReactComponent };